var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _g3, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountEmptyTransactionsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 155,
    viewBox: "0 0 166 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.217 125.151C120.778 125.151 147.176 98.7531 147.176 66.0755C147.176 33.3979 120.662 7 88.217 7C55.6557 7 29.2578 33.3979 29.2578 66.0755C29.2578 98.7531 55.6557 125.151 88.217 125.151Z",
    fill: "#373C47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.66 47.3581C157.294 47.3581 159.428 45.2234 159.428 42.5902C159.428 39.9569 157.294 37.8223 154.66 37.8223C152.027 37.8223 149.893 39.9569 149.893 42.5902C149.893 45.2234 152.027 47.3581 154.66 47.3581Z",
    fill: "#333741"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.639 28.7515C163.437 28.7515 164.895 27.2937 164.895 25.4954C164.895 23.6971 163.437 22.2393 161.639 22.2393C159.841 22.2393 158.383 23.6971 158.383 25.4954C158.383 27.2937 159.841 28.7515 161.639 28.7515Z",
    fill: "#333741"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9319 27.3502C33.7302 27.3502 35.188 25.8923 35.188 24.094C35.188 22.2957 33.7302 20.8379 31.9319 20.8379C30.1336 20.8379 28.6758 22.2957 28.6758 24.094C28.6758 25.8923 30.1336 27.3502 31.9319 27.3502Z",
    fill: "#363B46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0471 90.1479C15.3868 90.1479 18.0942 87.4405 18.0942 84.1008C18.0942 80.7611 15.3868 78.0537 12.0471 78.0537C8.70738 78.0537 6 80.7611 6 84.1008C6 87.4405 8.70738 90.1479 12.0471 90.1479Z",
    fill: "#333741"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16493_6364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.216 121.858H37.5801C35.6586 121.858 34.082 120.282 34.082 118.36V94.2676C34.082 92.3461 35.6586 90.7695 37.5801 90.7695H136.216C138.138 90.7695 139.714 92.3461 139.714 94.2676V118.36C139.714 120.282 138.138 121.858 136.216 121.858Z",
    fill: "url(#paint0_linear_16493_6364)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.86 102.446H64.9252C63.7427 102.446 62.8066 101.728 62.8066 100.82C62.8066 99.9127 63.7427 99.1943 64.9252 99.1943H119.86C121.042 99.1943 121.979 99.9127 121.979 100.82C121.979 101.728 121.042 102.446 119.86 102.446Z",
    fill: "#474E61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.152 112.349H64.9252C63.7427 112.349 62.8066 111.631 62.8066 110.724C62.8066 109.816 63.7427 109.098 64.9252 109.098H100.152C101.335 109.098 102.271 109.816 102.271 110.724C102.271 111.631 101.335 112.349 100.152 112.349Z",
    fill: "#474E61"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6663 115.059C53.5098 115.059 57.4362 111.133 57.4362 106.289C57.4362 101.446 53.5098 97.5195 48.6663 97.5195C43.8229 97.5195 39.8965 101.446 39.8965 106.289C39.8965 111.133 43.8229 115.059 48.6663 115.059Z",
    fill: "#474E61"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1291 104.29L46.611 109.759L45.2031 108.338L50.7212 102.869L52.1291 104.29Z",
    fill: "#656E87"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.611 102.869L52.1291 108.338L50.7212 109.759L45.2031 104.29L46.611 102.869Z",
    fill: "#656E87"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16493_6364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.529 42.5086H40.8926C38.9711 42.5086 37.3945 40.932 37.3945 39.0105V14.918C37.3945 12.9965 38.9711 11.4199 40.8926 11.4199H139.529C141.45 11.4199 143.027 12.9965 143.027 14.918V39.0105C143.027 40.932 141.45 42.5086 139.529 42.5086Z",
    fill: "url(#paint1_linear_16493_6364)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.172 23.0965H68.2377C67.0552 23.0965 66.1191 22.3781 66.1191 21.4706C66.1191 20.5631 67.0552 19.8447 68.2377 19.8447H123.172C124.355 19.8447 125.291 20.5631 125.291 21.4706C125.291 22.3781 124.355 23.0965 123.172 23.0965Z",
    fill: "#474E61"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.465 32.9998H68.2377C67.0552 32.9998 66.1191 32.2814 66.1191 31.3739C66.1191 30.4665 67.0552 29.748 68.2377 29.748H103.465C104.647 29.748 105.583 30.4665 105.583 31.3739C105.583 32.2814 104.647 32.9998 103.465 32.9998Z",
    fill: "#474E61"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9788 35.7096C56.8223 35.7096 60.7487 31.7832 60.7487 26.9398C60.7487 22.0963 56.8223 18.1699 51.9788 18.1699C47.1354 18.1699 43.209 22.0963 43.209 26.9398C43.209 31.7832 47.1354 35.7096 51.9788 35.7096Z",
    fill: "#474E61"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4416 24.9401L49.9235 30.4089L48.5156 28.9884L54.0337 23.5195L55.4416 24.9401Z",
    fill: "#656E87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9235 23.5195L55.4416 28.9884L54.0337 30.4089L48.5156 24.9401L49.9235 23.5195Z",
    fill: "#656E87"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_16493_6364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.391 81.9969H25.7051C23.7836 81.9969 22.207 80.4202 22.207 78.4988V54.4063C22.207 52.4848 23.7836 50.9082 25.7051 50.9082H124.341C126.263 50.9082 127.839 52.4848 127.839 54.4063V78.4988C127.889 80.4695 126.312 81.9969 124.391 81.9969Z",
    fill: "url(#paint2_linear_16493_6364)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8402 75.2467C41.6836 75.2467 45.61 71.3203 45.61 66.4769C45.61 61.6334 41.6836 57.707 36.8402 57.707C31.9967 57.707 28.0703 61.6334 28.0703 66.4769C28.0703 71.3203 31.9967 75.2467 36.8402 75.2467Z",
    fill: "#474E61"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6855 64.425L35.4603 70.6502L31.9941 67.184L33.4084 65.7698L35.4603 67.8217L40.2713 63.0107L41.6855 64.425Z",
    fill: "#656E87"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.034 62.5848H53.099C51.9166 62.5848 50.9805 61.8663 50.9805 60.9589C50.9805 60.0514 51.9166 59.333 53.099 59.333H108.034C109.216 59.333 110.152 60.0514 110.152 60.9589C110.152 61.8663 109.167 62.5848 108.034 62.5848Z",
    fill: "#474E61"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3263 72.5369H53.099C51.9166 72.5369 50.9805 71.8185 50.9805 70.911C50.9805 70.0036 51.9166 69.2852 53.099 69.2852H88.3263C89.5087 69.2852 90.4448 70.0036 90.4448 70.911C90.3956 71.8185 89.4594 72.5369 88.3263 72.5369Z",
    fill: "#474E61"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16493_6364",
    x: 12.082,
    y: 79.7695,
    width: 149.633,
    height: 75.0889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16493_6364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16493_6364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16493_6364",
    x: 15.3945,
    y: 0.419922,
    width: 149.633,
    height: 75.0889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16493_6364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16493_6364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_16493_6364",
    x: 0.207031,
    y: 39.9082,
    width: 149.633,
    height: 75.0889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16493_6364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16493_6364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16493_6364",
    x1: 86.8638,
    y1: 90.0504,
    x2: 86.8638,
    y2: 122.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#676F86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16493_6364",
    x1: 90.1763,
    y1: 10.7008,
    x2: 90.1763,
    y2: 42.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#676F86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16493_6364",
    x1: 74.9894,
    y1: 50.1891,
    x2: 74.9894,
    y2: 82.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#676F86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountEmptyTransactionsDark);
export default __webpack_public_path__ + "static/media/account-empty-transactions-dark.7999cb5ee03909e7bfe48fada4c54ad3.svg";
export { ForwardRef as ReactComponent };